document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.vehicle-swiper', {
        slidesPerView: 2.3,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            400: { slidesPerView: 3.2 },
            500: { slidesPerView: 3.7 },
            640: { slidesPerView: 4 },
            768: { slidesPerView: 6 },
            1024: { slidesPerView: 8 },
            1280: { slidesPerView: 10 },
        },
    });
});
